<div class="row">
	<p class="col-sm-3 ordina_data">
	  <label for="cerca-list-cont">Cerca</label> <input id="cerca-list-cont" type="text" #searchItem (keyup)="0"
		class="form-control" placeholder="Inserisci nome e cognome" />
	</p>
	<p class="col-sm-3 col-md-offset-6">
	  <label for="ordina_data-contr-list">Ordina per:</label> <select autocomplete="off" id="ordina_data-contr-list" class="form-control"
		#orderByValue (change)="0">
		<!-- <option value="controparte.dataAssociazione:ASC">Data Associazione</option> -->
		<option value="controparte.dataTermine:ASC">Data rinuncia</option>
		<option value="controparte.parte.nominativo:ASC">Nome</option>
	  </select>
	</p>
</div>
<ul class="controparti m0">
	<li class="panel" *ngFor="let option of optionsList | searchFilter : searchItem.value :'controparte.parte.nominativo' | orderBy : orderByValue.value; let indice = index">
		<div class="data_opzioni menu">
			<ul>
				<li *ngIf="writable" class="opzioni" appDropdownFocus><a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button"
						aria-haspopup="true" aria-expanded="false">Opzioni<span
							class="glyphicon glyphicon-option-vertical"></span></a>
					<div class="dropdown-menu">
						<ul>
							<li><a href="javascript:void(0)" (click)="setAsPrimaria(option.controparte)"><span
										class="glyphicon glyphicon-star"></span>Imposta come primaria</a>
							</li>

							<li><span class="glyphicon glyphicon-paperclip"></span><a href="javascript:void(0);"
									(click)="displayAddDocModal(sezione, option.controparte)">Allega
									documento</a>
							</li>

							<li><span class="glyphicon glyphicon-ban-circle"></span><a href="javascript:void(0)"
									(click)="disattivaControparte(option.controparte)">Disattiva</a>
							</li>

							<li><span class="glyphicon glyphicon-trash"></span><a href="javascript:void(0)"
									(click)="elimina(option.controparte)">Elimina</a>
							</li>

						</ul>
					</div>
				</li>
			</ul>
		</div>
		<div class="controparte">
			<div>
					<a
						href="#"
						role="button"
						class="collapsed"
						[class.accordion-collapse]="activeIndex === indice"
						[class.accordion-collapsed]="activeIndex !== indice"
						[attr.aria-expanded]="activeIndex === indice"
						[attr.aria-controls]="'subcontroparteModalAdd' + indice"
						id="accordion-header-controparti-{{indice}}"
						(click)="openDetail(option, indice); $event.preventDefault()">
							<span aria-live="polite" class="sr-only">{{ activeIndex === indice ? 'Chiudi dettaglio' : 'Apri dettaglio' }}</span>
					</a>


				<p class="col-sm-3 button-associa">
					<button class="btn btn-danger associa disassocia"
						[disabled]="option.controparte.primario && optionsList.length > 1"
						(click)="disassocia(option, indice)">{{labelButton}}</button>
				</p>
				<p class="titolo col-sm-3 mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
						{{option.controparte.parte.cognome}} {{option.controparte.parte.nome}}
				</p>
				<p class="titolo col-sm-3 mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
						{{option.controparte.parte.ragioneSociale}}
				</p>
				<p class="col-sm-3 matricola mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					C/F: <strong>{{option.controparte.parte.codiceFiscale}}</strong>
				</p>
				<p class="col-sm-3 matricola mt-5"
					*ngIf="option.controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					P.IVA: <strong>{{option.controparte.parte.partitaIva}}</strong>
				</p>
        <ng-template [ngIf]="option.controparte.ritirato">
          <p class="col-sm-2 status mt-5">Rinunciatario</p>
        </ng-template>
				<p class="col-sm-3 matricola mt-5"
					*ngIf="!option.controparte.parte.id || option.controparte.parte.id.startsWith('TEMP')">
					<span class="label label-success">Nuova anagrafica</span>
				</p>


				<ng-template [ngIf]="option.controparte.primario" class="col-sm-2">
					<div class="star"></div>
				</ng-template>
				<div></div>
				<!--
				<p class="col-sm-1 mt-5" *ngIf="option.controparte.primario">
					<li class="star"></li>
				</p> -->

			</div>
		</div>
		<ul class="{{activeIndex === indice ? 'collapsed' : 'collapse'}} subcontroparte">

			<li>
				<div class="container_dati_generali">
					<div class="container_tab_nav">
						<!-- NAVIGATION TABS ACCESSIBILE -->
						<ul class="nav nav-tabs two"
							role="tablist">
						
							<!-- TAB ASSOCIATIVA -->
							<li role="presentation"
								[style.width.%]="50"
								class="tab-link-nav">
								<button
									id="tab-associativa-controparti"
									class="btn-link"
									role="tab"
									type="button"
									[attr.aria-selected]="currentTab === 'ASSOCIATIVA'"
									[attr.aria-controls]="'panel-associativa'"
									[class.active]="currentTab === 'ASSOCIATIVA'"
            						[class.inactive]="currentTab !== 'ASSOCIATIVA'"
									(click)="currentTab = 'ASSOCIATIVA'">
										Associativa
								</button>
							</li>

							<!-- TAB ANAGRAFICA -->
							<li role="presentation"
								[style.width.%]="50"
								class="tab-link-nav">
								<button
									id="tab-anagrafica-controparti"
									class="btn-link"
									role="tab"
									type="button"
									[attr.aria-selected]="currentTab === 'ANAGRAFICA'"
									[attr.aria-controls]="'panel-anagrafica'"
									[class.active]="currentTab === 'ANAGRAFICA'"
            						[class.inactive]="currentTab !== 'ANAGRAFICA'"
									(click)="currentTab = 'ANAGRAFICA'">
										Anagrafica
								</button>
							</li>
						</ul>

						<div class="tab-content">
							<div *ngIf="currentTab === 'ASSOCIATIVA'" class="tab-pane fade active in">
								<div class="row">
									<div *ngIf="editing" class="col-12">
										<associazione-controparte-form
											[primariaPreselected]="optionsList.length === 1 || (optionsList.length  > 1 && option.controparte.primario)"
											[controparte]="option.controparte" [parte]="option.controparte.parte"
											[position]="indice"
											(onReturn)="retrieveControparte($event)"></associazione-controparte-form>
									</div>
									<div *ngIf="!editing" class="col-12">
										<app-associativa-controparti [controparte]="option.controparte">
										</app-associativa-controparti>
									</div>
								</div>
								<div class="row" *ngIf="!editing">
									<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
										<button type="button" class="btn btn-primary btn-block"
											(click)="editing = true">Modifica
											dati</button>
									</p>
								</div>
								<div class="row" *ngIf="editing">
									<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
										<button type="button" class="btn btn-secondary btn-block"
											(click)="editing = false">Annulla</button>
									</p>
								</div>
							</div>
							<div *ngIf="currentTab === 'ANAGRAFICA'" class="tab-pane fade active in">
								<div class="row">
									<div *ngIf="!editing" class="col-12">
										<app-dati-generali-anagrafiche-search
											[option]="{hasDetailsAnagrafica:false ,anagrafica:option.controparte.parte}"
											[isLegale]="isLegale" [isPartiSearch]="true"
											[isControparte]="isControparte">
										</app-dati-generali-anagrafiche-search>
									</div>
									<div *ngIf="editing" class="col-12">
										<anagrafica-parte-form
											[isParteForm]="true"
											(parteChange)="onEmitUpdateAnagrafica($event, option.controparte)"
											[parte]="option.controparte.parte">
										</anagrafica-parte-form>
									</div>
								</div>
								<div class="row" *ngIf="!editing">
									<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
										<button type="button" class="btn btn-primary btn-block"
											(click)="editing = true">Modifica
											dati</button>
									</p>
								</div>
								<div class="row" *ngIf="editing">
									<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
										<button type="button" class="btn btn-secondary btn-block"
											(click)="editing = false">Annulla</button>
									</p>
								</div>
							</div>
						</div>
					</div>

					<ng-template [ngIf]="option.controparte.documenti.length > 0">
						<p>Documentazione allegata</p>
						<ul documenti_allegati_lista=""
							[documenti]="option.controparte.documenti" [subdoc]="false"
							[nomeCampoId]="nomeCampoId"
							[writable]="writable"
							[fascicolo]="fascicolo"
							(onReturn)="onReturnUpdateCallback($event)"
							(openModal)="showUploadNewVersionModal($event)"
							(openHistoryModal)="showHistoryModal($event)"
							(removDoc)="removeDoc($event, option.controparte.id, sezione.id)"
							(onOpenUpdateMetadatiModal)="displayDocUpdateMetadatiModal($event)">
						</ul>
					</ng-template>

				</div>
			</li>

		</ul>
	</li>
</ul>
